import { useState } from "react";
import { FAQS } from "../../data/content";
import { Plus, Minus } from "lucide-react";

export default function FAQs() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faqs" data-testid="faqs-section" className="py-24 sm:py-32">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <p
            className="section-eyebrow"
            style={{ justifyContent: "center", display: "inline-flex" }}
          >
            <span className="divider-rule" /> Good to Know
          </p>
          <h2
            className="mt-5 font-serif text-4xl sm:text-5xl tracking-tight"
            style={{ color: "var(--dl-ink)", fontWeight: 400 }}
          >
            Frequently asked
            <br />
            <span className="serif-italic">questions.</span>
          </h2>
        </div>

        <div data-testid="faq-list">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className="dl-accordion-item"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="dl-accordion-trigger"
                  data-testid={`faq-trigger-${i}`}
                  aria-expanded={isOpen}
                >
                  <span>{item.q}</span>
                  {isOpen ? <Minus size={20} /> : <Plus size={20} />}
                </button>
                {isOpen && (
                  <div
                    className="dl-accordion-panel"
                    data-testid={`faq-panel-${i}`}
                  >
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
